import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './NoKnowledgeModal.css';

const NoKnowledgeModal = ({ open, onClose, onManageKnowledge }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          padding: isMobile ? '20px' : '30px',
          width: isMobile ? '85%' : '90%',
          maxWidth: 460,
          '& .nk-modal-close': { position: 'absolute' },
        }}
      >
        <button className="nk-modal-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="nk-modal-icon">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </div>
        <h2 className="nk-modal-title">{t('nk_no_knowledge_title')}</h2>
        <div className="nk-modal-body">
          <p>{t('nk_no_knowledge_body')}</p>
          <p style={{ marginBottom: 0 }}>
            <Trans i18nKey="nk_no_knowledge_body2_html" components={{ strong: <strong /> }} />
          </p>
        </div>
        <div className="nk-modal-actions">
          <button className="nk-modal-btn" onClick={onManageKnowledge}>
            {t('nk_manage_knowledge')}
          </button>
          <button className="nk-modal-btn secondary" onClick={onClose}>
            {t('nk_continue_without_knowledge')}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default NoKnowledgeModal;
